module.exports = __webpack_public_path__ + "72c637af1e192d6ff6f745a65d73daf7.svg";